/**
 * Helpers for surfacing disciplined-compose storyboard data (archetype + intent) inside the
 * Outline cards. The Outline IS the storyboard for kubicle disciplined-compose videos.
 */
import type { StoryboardMeta } from '@/types/outline';

// Public CloudFront base for the kubicle design-system archetype previews (preview.png per layout).
const PREVIEW_BASE = 'https://d2hx6jpyk06ley.cloudfront.net/design-systems/kubicle/1.0.0/layouts';

/** Resolve the golden archetype preview image for a scene (or null if none). */
export function archetypePreviewUrl(sb?: StoryboardMeta | null): string | undefined {
  if (!sb) return undefined;
  if (sb.previewUrl) return sb.previewUrl;
  if (!sb.archetypeKey) return undefined;
  return `${PREVIEW_BASE}/${encodeURIComponent(sb.archetypeKey)}/preview.png`;
}

export const TIER_BADGE_STYLE: Record<string, string> = {
  A: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-400',
  B: 'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-400',
  C: 'bg-accent text-accent-foreground dark:bg-primary/20',
};

export const TIER_LABEL: Record<string, string> = {
  A: 'Tier A · golden',
  B: 'Tier B · composed',
  C: 'Tier C · generative',
};
